import React from "react";

export default function HouseManual() {
  return (
    <div className="relative h-screen mx-auto overflow-hidden max-w-7xl">
      <iframe
        src="https://drive.google.com/file/d/1IiVc8tJXeCnbC4J4hIAy3lZuna_aXBLV/preview"
        width="85%"
        height="100%"
        allow="autoplay"
      />
    </div>
  );
}
